import { InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';
import whatsappIcon from "../assets/images/whatsapp-icon.svg";
import { toast } from "react-toastify";
import { Link,useNavigate } from 'react-router-dom';
import axios from 'axios';

const LoginForm = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(''); // New state for error message
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (!phoneNumber.trim()) {
      setError(true);
      setErrorMessage("נא למלא את מספר הטלפון שלך");
      return;
    } 

    setError(false);
    setErrorMessage("");
    console.log('process.env.REACT_APP_BE_BASE_URL', process.env.REACT_APP_BE_BASE_URL);
    
    axios.post(`${process.env.REACT_APP_BE_BASE_URL}user/login?action=otp_generate`, {
      phone_number: process.env.REACT_APP_COUNTRY_CODE === "+972" ? `+972${phoneNumber.replace(/^\+972/, "").replace(/^0/, "").replaceAll("-", "").trim()}` :  `+91${phoneNumber.replace(/^\+91/, "").replace(/^0/, "").replaceAll("-", "").trim()}`,
    })
    .then((res) => {
      toast.success("Data is successfully saved");
      navigate('/otp?from=login', { state: { phoneNumber } });
    })
    .catch((err) => {
      setError(true);
      setErrorMessage(err && err.response && err.response.data && err.response.data.message ? err.response.data.message : "שליחת קוד האימות נכשלה. אנא נסה שוב.");
      toast.error("Failed to save data, please try again");
    });
  };

  const handlePhoneChange = (e) => {
    // console.log('e.code', e.code);
    
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      handleSubmit();
    }
  };

  return (
    <div className='form_box'>
      <h2 className="box_head">הגיע הזמן לעשות סדר <br/>בפנסיה ובביטוחים שלך</h2>

      <p className='login_label'>מספר טלפון</p>
      <TextField
        type='tel'
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        onKeyUp={(e) => handlePhoneChange(e)}
        error={error}
        helperText={errorMessage}
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            borderRadius: window.innerWidth < 767 ? "5px" : "10px",
            '&:hover fieldset': {
              borderColor: '#1b7870', 
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1b7870',
            },
            '&.Mui-error fieldset': {
              borderColor: '#fc4747', 
            },
          },
          '& .MuiFormHelperText-root': {
            color: '#fc4747 !important', 
            textAlign: 'right', 
            fontWeight: 500,
            marginRight: "0px" 
          },
        }}
        size={window.innerWidth < 767 ? 'small' : "medium"}
        id="outlined-basic"
        placeholder=""
        variant="outlined"
      />

      {/* {errorMessage && <p style={{ color: "red", padding: 10 }}>{errorMessage}</p>} */}

      <button className='login_btn' onClick={handleSubmit}>
        שלחו לי קוד כניסה בSMS
      </button>
      <div className='text-center' onClick={()=> navigate('/register?step=1')}>
        <span className='link_btn'>
          לא רשום עדיין? לחץ כאן להרשמה

        </span>
      </div>
      

    </div>
  );
};

export default LoginForm;
